<template>
  <el-card class="h-full">
    <div class="w-full h-full flex flex-col">
      <div class="flex mb-20px mr-10px">
        <el-input
          size="small"
          class="mr-10px w-200px"
          placeholder="姓名"
          v-model="searchData.personName"
          clearable
        ></el-input>
        <SelectTree
          :optionList="projectList"
          :value="searchData.orgIndexCodes"
          :treeProps="{
            label: 'orgName',
            children: 'children',
          }"
          nodeKey="orgIndexCode"
          placeholder="所属组织"
          class="mr-10px"
          @change="setOrgIndexCodes"
        ></SelectTree>
        <el-select
          v-model="searchData.attendanceStatus"
          size="small"
          class="mr-10px"
          placeholder="考勤状态"
          clearable
        >
          <el-option
            v-for="item in attendanceStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          v-model="searchData.entryApprovalStatus"
          size="small"
          placeholder="入场审批状态"
          class="mr-10px"
          clearable
        >
          <el-option
            v-for="item in entryApprovalStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button size="small" type="primary" @click="tableSizeChange">搜索</el-button>
        <el-button size="small" @click="resetSearch">重置</el-button>
        <el-button
          size="small"
          type="danger"
          @click="deleteAccessControl"
          :disabled="!$hasAccess('delete')"
          :loading="deleteLoading"
          >删除门禁权限</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="exportTableList"
          :disabled="!$hasAccess('export')"
          :loading="exportLoading"
          >导出</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="openClockingInDialog"
          :disabled="!$hasAccess('clockingIn')"
          >考勤配置</el-button
        >
      </div>
      <div class="flex-auto h-0px">
        <el-table
          :data="dataList"
          border
          height="100%"
          stripe
          v-loading="tableLoading"
          :row-key="(record) => record.id"
          @selection-change="handleSelectionChange"
          ref="tableRef"
        >
          <el-table-column
            type="selection"
            :reserve-selection="true"
            width="50"
            align="center"
          ></el-table-column>
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="姓名" prop="orgPathName" show-overflow-tooltip></el-table-column>
          <el-table-column
            label="所属组织"
            prop="projectNames"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="电话" prop="phone" show-overflow-tooltip></el-table-column>
          <el-table-column
            label="身份证号码"
            prop="certificateNo"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="最新门禁记录"
            prop="lastAccessRecordTime"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="考勤状态" prop="attendanceStatus">
            <template #default="{ row: { attendanceStatus } }">
              <el-tag size="mini" :type="attendanceStatus === 1 ? 'success' : 'danger'">
                {{ attendanceStatus ? '正常' : '异常' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="入厂审批状态">
            <template #default="{ row: { entryApprovalStatus } }">
              <el-tag size="mini" :type="entryApprovalStatusList[entryApprovalStatus + 1].type">
                {{ entryApprovalStatusList[entryApprovalStatus + 1].label }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="mt-20px text-right">
        <el-pagination
          background
          @size-change="tableSizeChange"
          @current-change="getTableList"
          :current-page.sync="pageConfig.pageNo"
          :page-size.sync="pageConfig.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[15, 30, 45, 60, 75, 90, 100]"
          :total="pageConfig.totalCount"
        ></el-pagination>
      </div>
    </div>

    <!-- 考勤配置弹窗 start -->
    <ClockingInDialog
      v-if="showClockingInDialog"
      :visible.sync="showClockingInDialog"
      @success="tableSizeChange"
    ></ClockingInDialog>
    <!-- 考勤配置弹窗 end -->
  </el-card>
</template>

<script>
import { HikOrgPersonApi } from '@wiz-api/shi-men'
import { ContractorPersonnelApi } from '@wiz-api/contractor-management'
import { map } from 'lodash'

const hikOrgPersonApi = new HikOrgPersonApi()
const contractorPersonnelApi = new ContractorPersonnelApi()
const SelectTree = () => {
  return import('../components/SelectTree')
}
const ClockingInDialog = () => {
  return import('../components/ClockingInDialog')
}
export default {
  name: 'access-control-system',
  components: {
    SelectTree,
    ClockingInDialog,
  },
  data() {
    return {
      tableLoading: false, // 列表loading
      dataList: [], // 列表数据
      searchData: {
        personName: '', // 姓名
        orgIndexCodes: '', // 所属组织
        status: null, // 施工单位
        attendanceStatus: null, // 考勤状态
        entryApprovalStatus: null, // 入场审批状态
      },
      pageConfig: {
        pageNo: 1, // 页码
        pageSize: 15, // 分页数
        totalCount: 0, // 总数
      },
      entryApprovalStatusList: [
        {
          label: '未办理',
          value: -1,
          type: 'danger',
        },
        {
          label: '待提交',
          value: 0,
          type: 'info',
        },
        {
          label: '审核中',
          value: 1,
          type: 'primary',
        },
        {
          label: '已审批',
          value: 2,
          type: 'success',
        },
        {
          label: '被驳回',
          value: 3,
          type: 'warning',
        },
      ], // 入厂审批状态
      projectList: [], // 所属组织
      projectLoading: false, // 所属组织列表loading
      attendanceStatusList: [
        {
          label: '异常',
          value: 0,
        },
        {
          label: '正常',
          value: 1,
        },
      ], // 考勤状态
      selectedList: [], // 列表数据勾选项
      showClockingInDialog: false, // 是否显示考勤配置弹窗
      exportLoading: false, // 导出按钮loading
      deleteLoading: false, // 删除按钮loading
    }
  },
  created() {
    this.getTableList()
    this.getProjectList()
  },
  methods: {
    /**
     * @description 获取列表数据
     */
    async getTableList() {
      this.tableLoading = true
      const [err, res] = await hikOrgPersonApi.hikPersonList({
        body: {
          ...this.searchData,
          maxResultCount: this.pageConfig.pageSize, // 每页多少条
          skipCount: (this.pageConfig.pageNo - 1) * this.pageConfig.pageSize, // 跳过多少条
        },
      })
      if (!err) {
        this.dataList = res.items
        this.pageConfig.totalCount = res.totalCount
      }
      this.tableLoading = false
    },

    /**
     * @description 获取所属组织列表
     */
    async getProjectList() {
      this.projectLoading = true
      const [err, res] = await hikOrgPersonApi.getHikOrgList()
      if (!err) {
        this.projectList = res
      }
      this.projectLoading = false
    },

    /**
     * @description 设置所属组织查询条件
     */
    setOrgIndexCodes(id) {
      this.searchData.orgIndexCodes = id
    },

    /**
     * @description 导出列表数据
     */
    async exportTableList() {
      this.exportLoading = true
      const [err, res] = await hikOrgPersonApi.exportHikPersonList({
        body: {
          ...this.searchData,
          personIds: map(this.selectedList, 'personId'),
          pageNo: this.pageConfig.pageNo,
          pageSize: this.pageConfig.pageSize,
        },
      })
      this.exportLoading = false
      if (!err) {
        this.downloadBlob({
          name: `${this.$t('门禁系统人员清单')}.xlsx`,
          data: res,
        })
      }
    },

    /**
     * @description 文件流下载
     */
    downloadBlob(data) {
      const blob = new Blob([data.data])
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = data.name
      link.click()
      window.URL.revokeObjectURL(link.href)
    },

    /**
     * @description 删除门禁权限
     */
    async deleteAccessControl() {
      if (!this.selectedList.length) {
        this.$message.warning('请先勾选数据')
        return
      }
      this.deleteLoading = true
      const [err, res] = await contractorPersonnelApi.deleteHikvisionUserInfo({
        idCards: map(this.selectedList, 'certificateNo'),
      })
      this.deleteLoading = false
      if (!err) {
        this.$message.success('成功')
        this.$refs.tableRef && this.$refs.tableRef.clearSelection()
        this.tableSizeChange()
      }
    },

    /**
     * @description 列表勾选
     */
    handleSelectionChange(selectedList) {
      this.selectedList = selectedList
    },

    /**
     * @description 重置搜索条件
     */
    resetSearch() {
      this.searchData = this.$options.data().searchData
      this.tableSizeChange()
    },

    /**
     * @description 打开考勤配置弹窗
     */
    openClockingInDialog() {
      // if (!this.selectedList.length) {
      //   this.$message.warning('请先勾选数据')
      //   return
      // }
      this.showClockingInDialog = true
    },

    /**
     * @description 分页数改变
     */
    tableSizeChange() {
      this.pageConfig.pageNo = 1
      this.getTableList()
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
